import { jsPDF } from 'jspdf';
import {
  calculateImageHeight,
  calculateVerticalMargin,
  createNewJsPdf,
  determineTopologyTitleOverflowCoordinate,
  getImageWidth,
} from './utils';
import { createPdf } from './createPdf';

export const generatePdf = ({
  canvasDataUrl,
  canvas,
  size,
  orientation,
  name,
  ciscoLogoDataUrl,
}: ExportGeneratePdf): jsPDF => {
  const pdf = createNewJsPdf(size, orientation);
  const imageWidth = getImageWidth(size, orientation);
  const imageHeight = calculateImageHeight(canvas, imageWidth);
  const verticalMargin = calculateVerticalMargin(pdf, imageHeight);
  const topologyTitleOverflowCoordinate =
    determineTopologyTitleOverflowCoordinate(size, orientation);

  return createPdf({
    canvasDataUrl,
    ciscoLogoDataUrl,
    imageHeight,
    imageWidth,
    name,
    pdf,
    topologyTitleOverflowCoordinate,
    verticalMargin,
  });
};
